import { io } from 'socket.io-client'

export const SOCKET = io(process.env.REACT_APP_SERVER_URL)

export const SOCKET_EVENTS = {
  receiveTrackedScenes: 'receive-tracked-scenes',
  receiveSegmentedScenes: 'receive-segmented-scenes',
}
